import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import Membresias from "./Membresias";
import Anualidad from "./Anualidad";
import NochesUsuario from "./NochesUsuario";
import Libreaciones from "./Liberaciones";
import { useTranslation } from "react-i18next";


const MembresiaMain = () => {
    const { t } = useTranslation();
    return (
        <Tabs isLazy>
            <TabList>
                <Tab>
                    {t('MEMBERSHIPS')}
                </Tab>
                <Tab>
                    {t('ANNUALITIES')}
                </Tab>
                <Tab>
                    {t('NIGHTS')}
                </Tab>
                <Tab>
                    {t('RELEASED_NIGHTS')}
                </Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <Membresias/>
                </TabPanel>
                <TabPanel>
                    <Anualidad/>
                </TabPanel>
                <TabPanel>
                    <NochesUsuario/>
                </TabPanel>
                <TabPanel>
                    <Libreaciones/>
                </TabPanel>
            </TabPanels>
        </Tabs>
    )
}

export default MembresiaMain;